import Service from "../../../Services/index";

const FactorialMaterialExport = {
    namespaced: true,
    state: {
        factorialMaterialExportList: [],
        form: {
            id: "",
            factorial_id: "",
            user_id: "",
            quantity: "",
            technical: "",
            remark: "",
            date: "",
            onSave: false
        },
        search: {
            name: "",
            source_id: "",
            date: ""
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        GET_FACTORIAL_MATERIAL: (state, res) => {
            state.factorialMaterialExportList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_FACTORIAL_MATERIAL_BY_ID: (state, res) => {
            state.form = res;
        },
        CLEAR_FORM_DATA: (state) => {
            state.form = {
                id: "",
                factorial_id: "",
                user_id: "",
                quantity: "",
                technical: "",
                remark: "",
                date: "",
                onSave: false
            }
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                name: "",
                source_id: "",
                date: ""
            }
        }
    },
    actions: {
        setFactorialMaterialExport({commit}, page = 1) {
            return Service.FactorialMaterialExport.getFactorialMaterialExport(page).then(data => {
                commit("GET_FACTORIAL_MATERIAL", data);
            });
        },
        saveFactorialMaterialExport({commit}, data) {
            if (!data.id) {
                return Service.FactorialMaterialExport.createFactorialMaterialExport(data).then(res => {
                    //console.log("create");
                });
            } else {
                return Service.FactorialMaterialExport.updateFactorialMaterialExport(data.id, data).then(res => {
                    //console.log("update");
                });
            }
        },
        showFactorialMaterialExportByID({commit}, id) {
            return Service.FactorialMaterialExport.showFactorialMaterialExport(id).then(res => {
                commit("GET_FACTORIAL_MATERIAL_BY_ID", res);
                return res;
            })
        },
        delete({commit}, id) {
            return Service.FactorialMaterialExport.deleteFactorialMaterialExport(id)
                .catch(err => {
                    console.error(err);
                });
        },
        search({commit}, data) {
            return Service.FactorialMaterialExport.searchFactorialMaterialExport(data).then(res => {
                commit("GET_FACTORIAL_MATERIAL", res)
            })
        },
        clearFormData({commit}) {
            commit("CLEAR_FORM_DATA");
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
    }
};

export default FactorialMaterialExport;
